import { timeParse } from "d3";
import { EEventId, IKinder } from "./Entities";
import { ModelAdapter } from "./MBase";

const formatHMS = timeParse("%H:%M:%S");


export class MEscuela extends ModelAdapter<IKinder> implements IKinder {
    Correo: string;
    Direccion: string;
    HoraEntrada: string;
    HoraSalida: string;
    Nombre: string;
    Sabado: boolean;
    Telefono: string;
    TieneSecundario: boolean;
    TipoChat: number;
    BolQr: boolean;
    IdKinder: number;
    ModuloEval: EEventId.MILLESTONE | EEventId.EVALUATION;
    /** 0 = Inactivo, 1 = Activo */
    KidiRadarEstado: 0 | 1;

    /** Propiedad auxiliar */
    DTHoraEntrada: Date | null;
    /** Propiedad auxiliar */
    DTHoraSalida: Date | null;

    constructor(data: IKinder) {
        super(data);

        this.DTHoraEntrada = data.HoraEntrada ? formatHMS(data.HoraEntrada) : null;
        this.DTHoraSalida = data.HoraSalida ? formatHMS(data.HoraSalida) : null;
    }

    getKidiRadarActivo(): boolean {
        return this.KidiRadarEstado === 1;
    }
}